export default __webpack_public_path__ + "static/media/clouds.2058006a.svg";